
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import {UserConfigService} from "@/services";
export default Vue.extend({
	data() {
		return {
			AutoUpdateProductComposition: false,
			GetPurchasePriceFromProductWhenZero: false,
			ShowSupplierFilterOnPriceListOpen: false
		};
	},
	computed: {
		path():IBreadCrumb[] {
			return [
				{to: "/settings", value: this.$ct("general")},
				{to: "/settings/products", value: this.$ct("products")},
				{value: this.$ct("taxes")}
			] as IBreadCrumb[];
		},
	},
	methods: {
		async save(){
			let settings = UserConfigService.getGeneralSettings();
			settings.AutoUpdateProductComposition = this.AutoUpdateProductComposition;
			settings.GetPurchasePriceFromProductWhenZero = this.GetPurchasePriceFromProductWhenZero;
			settings.ShowSupplierFilterOnPriceListOpen = this.ShowSupplierFilterOnPriceListOpen;
			await UserConfigService.setGeneralSettings(settings);
		},
	},
	mounted(){
		this.AutoUpdateProductComposition = UserConfigService.getGeneralSettings().AutoUpdateProductComposition;
		this.GetPurchasePriceFromProductWhenZero = UserConfigService.getGeneralSettings().GetPurchasePriceFromProductWhenZero;
		this.ShowSupplierFilterOnPriceListOpen = UserConfigService.getGeneralSettings().ShowSupplierFilterOnPriceListOpen;
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
